import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import Handlebars from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.3/js/sparta-global-functions-utility";
import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/5.7.3/js/sparta-ui-layers-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.3.1/js/ah-caw-commons-utility";
import spartaValidationFramework from "utilities/global/sparta-validation-framework/7.1.5/js/sparta-validation-framework";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import "utilities/vendor/jsencrypt/2.3.1/js/jsencrypt";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.2/js/ah-caw-events-master-utility";
import ahCawTransportUtility from "utilities/login/ah-caw-transport-utility/2.2.3/js/ah-caw-transport-utility";
import fingerprintUtility from "utilities/login/fingerprint-utility/2.0.0/js/fingerprint-utility";
import textInput from "utilities/helpers/helpers-text-inputs/4.1.0/js/helpers-text-inputs";
import spartaInputUtility from "utilities/global/sparta-input-utility/12.1.1/js/sparta-input-utility";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import Module from "utilities/global/sparta-module-utility/6.2.6/js/sparta-module-utility";
import checkbox from "utilities/helpers/helpers-checkbox/4.2.6/js/helpers-checkbox";
import checkboxHelper from "utilities/helpers/helpers-checkbox/4.2.6/js/helpers-checkbox";
import spartaHelpers from "utilities/helpers/helpers-sparta/2.3.5/js/helpers-sparta";
import radioButton from "utilities/helpers/helpers-radio-button/4.3.1/js/helpers-radio-button";
import select from "utilities/helpers/helpers-select/3.4.3/js/helpers-select";
import helpersSelect from "utilities/helpers/helpers-select/3.4.3/js/helpers-select";
import selectHelper from "utilities/helpers/helpers-select/3.4.3/js/helpers-select";
import textAreaHelper from "utilities/helpers/helpers-textarea/2.1.1/js/helpers-textarea";
import spartaTemplates from "modules/login/ah-secure-signin-module/8.4.1/js/templates";
import "css!modules/login/ah-secure-signin-module/8.4.1/css/ah-secure-signin-module.scss.css";






export default class ahSecureSigninModel {
    constructor(parentModule) {
        this.parentModule = parentModule;
        const self = this;
        this.bindThisConext(['_initialize'],
            self, '');
    }

    bindThisConext(methods, context, suffix = 'Scoped') {
        const self = context;

        if (methods && $.isArray(methods) && methods.length > 0) {
            $(methods).each((index, method) => {
                if (self[method]) {
                    self[method + suffix] = self[method].bind(context);
                } else {
                    console.log(`Method: ${method} Not found in current context.`);
                }
            });
        }
    }

    _defineVars() {
        const _model = this.parentModule.model;
        this.$moduleContext = $(_model.settings.target);
        this.widgetConfigData = { intialized: false };

        this.parentModule._debug('ahSecureSigninModel::defineVars');
        return this;
    }

    _bindEventHandlers() {
        return this;
    }

    _updateWidgetConfigData(event, data) {
        const _model = this.parentModule.model;

        this.widgetConfigData = data;
        _model.emit({ context: 'redraw-widget', data: this.widgetConfigData });
        this.parentModule._debug('ahSecureSigninModel::_updateWidgetConfigData');
        this.parentModule.publicKey = _.get(this.widgetConfigData, "initData.publicKey");

        this.parentModule.widgetConfigData = this.widgetConfigData;
    }


    _firstFactorSuccess(event, data) {
        this.parentModule._debug('ahSecureSigninModel::_firstFactorSuccess');


        if (this.widgetConfigData && this.widgetConfigData.successCallback &&
            $.isFunction(this.widgetConfigData.successCallback.firstFactor)) {
            this.widgetConfigData.successCallback.firstFactor();
        }
    }


    _updateCaptchaState(event, data) {
        this.parentModule.captchaState = data.captchaState;
    }

    _listen() {
        const _model = this.parentModule.model;
        _model.listen({ context: 'update-widget-configdata', caller: this, callback: this._updateWidgetConfigData });
        _model.listen({ context: 'first-factor-success', caller: this, callback: this._firstFactorSuccess });
        _model.listen({ context: 'update-captcha-state', caller: this, callback: this._updateCaptchaState });
        return this;
    }

    get widgetData() {
        return this.widgetConfigData;
    }

    _initialize() {
        this._defineVars()
            ._bindEventHandlers()
            ._listen();
    }
}
